module.exports = __webpack_public_path__ + "img/bell_3.53d8edac.jpg";